export const fmtDate = (d) => (d ? String(d).slice(0, 10).split("-").reverse().join("/") : "—");

export const fmtQty = (n) => {
  const v = Number(n) || 0;
  return Number.isInteger(v) ? String(v) : v.toFixed(2).replace(/\.?0+$/, "");
};

export const UNITS = ["un", "L", "ml", "kg", "g", "par", "cx"];

// PVPS — meta visual de validade (verde >7d, âmbar 3-7d, vermelho <48h)
export const expiryMeta = (expiresAt) => {
  if (!expiresAt) return null;
  const days = Math.ceil((new Date(expiresAt) - new Date()) / 86400000);
  const bar = days < 2 ? "bg-rose-500" : days <= 7 ? "bg-amber-500" : "bg-emerald-500";
  const textTone = days < 2 ? "text-rose-700" : days <= 7 ? "text-amber-700" : "text-emerald-700";
  const text = days < 0 ? `Vencido há ${Math.abs(days)}d` : days === 0 ? "Vence hoje" : `Vence em ${days}d`;
  const pct = days < 0 ? 100 : Math.max(6, Math.min(100, Math.round((days / 30) * 100)));
  return { days, bar, textTone, text, pct };
};

export function ExpiryCell({ expiresAt, compact = false }) {
  const meta = expiryMeta(expiresAt);
  if (!meta) return <span className="text-stone-400">—</span>;
  return (
    <div className={compact ? "min-w-[90px]" : "min-w-[110px]"}>
      <div className="flex items-center justify-between gap-2">
        <span className="tabular-nums">{fmtDate(expiresAt)}</span>
        <span className={`text-[10px] font-semibold ${meta.textTone}`}>{meta.text}</span>
      </div>
      <div className="h-1.5 rounded-full bg-stone-200 overflow-hidden mt-1">
        <div className={`h-full ${meta.bar}`} style={{ width: `${meta.pct}%` }} />
      </div>
    </div>
  );
}
